import { defineStyleConfig } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

// Exports
export const Drawer = defineStyleConfig({
  baseStyle: (props) => ({
    dialog: {
      backgroundColor: mode('white', 'gray.900')(props),
    },
  }),
});
